module.exports = __webpack_public_path__ + "static/vmware_4.1232cff4.jpg";